import { get } from './api';

export const pendingUsersApi = {
    getPendingUsers() {
        return get('admin/users/pending');
    }
};
